import React from "react";
import classNames from "classnames";
import { Flex, Header, Button, Text, FlexProps } from "@fluentui/react-northstar";
import { ChevronStartIcon, ChevronEndIcon } from "@fluentui/react-icons-northstar";
import { format } from "date-fns";
import { DateRange } from "shared/models/DateRange";
import { constants } from "shared/constants";
import styles from "./taskBoardWeekNavigation.module.scss";
import pl from "shared/messages/pl";
import ShowFiltersButton from "../boardFilters/ShowFiltersButton";

export interface TaskBoardWeekNavigationProps {
    range: DateRange;
    disabled?: boolean;
    isMobile?: boolean;

    onForwardClick: () => void;
    onBackwardClick: () => void;

    showFilters?: boolean;
    onShowFiltersClick?: () => void;
}

const TaskBoardWeekNavigation: React.FC<TaskBoardWeekNavigationProps> = (props: TaskBoardWeekNavigationProps) => {
    const mobileFlexProps: FlexProps = props.isMobile ? { space: "between", hAlign: "center" } : {};

    return (
        <Flex
            vAlign="center"
            gap="gap.small"
            {...mobileFlexProps}
            className={classNames(props.isMobile ? styles.mobileWrapper : styles.wrapper)}
        >
            <Header as="h3" className={styles.header}>
                {pl.taskBoard.header}
                <Text color="brand">
                    {format(props.range.start, props.isMobile ? constants.dayOnlyDateFormat : constants.dateFormat)}-
                    {format(props.range.end, constants.dateFormat)}
                </Text>
            </Header>
            <Button
                size="small"
                disabled={props.disabled}
                className={styles.backwardButton}
                iconOnly
                icon={<ChevronStartIcon size="small" />}
                onClick={props.onBackwardClick}
            />
            <Button
                size="small"
                disabled={props.disabled}
                className={styles.forwardButton}
                iconOnly
                icon={<ChevronEndIcon size="small" />}
                onClick={props.onForwardClick}
            />
            <ShowFiltersButton onClick={props.onShowFiltersClick!} isActive={props.showFilters!} />
        </Flex>
    );
};

export default TaskBoardWeekNavigation;
